/**
 * 接口域名的管理
 */
const base = {
  // // 开发环境
  baseURL: 'https://qzctec.com/api/counseling',
  baseURL_clinic: 'https://qzctec.com/api/counseling',

  // baseURL: 'http://localhost:8981/api/counseling',
  // baseURL_clinic: 'http://localhost:8981/api/counseling',
};
export default base;



// WEBPACK FOOTER //
// ./src/api/base.js